export const AUTHENTICATION_CHANGE_COMPANY = 'AUTHENTICATION_CHANGE_COMPANY';
export const AUTHENTICATION_COMPLETED = 'AUTHENTICATION_COMPLETED';
export const AUTHENTICATION_CREATE_COMPANY = 'AUTHENTICATION_CREATE_COMPANY';
export const AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE';
export const AUTHENTICATION_GET_COMPANIES_COMPLETED = 'AUTHENTICATION_GET_COMPANIES_COMPLETED';
export const AUTHENTICATION_GET_PROFILE = 'AUTHENTICATION_GET_PROFILE';
export const AUTHENTICATION_GET_PROFILE_COMPLETED = 'AUTHENTICATION_GET_PROFILE_COMPLETED';
export const AUTHENTICATION_GET_PROFILE_FAILURE = 'AUTHENTICATION_GET_PROFILE_FAILURE';
export const AUTHENTICATION_INITIALIZED = 'AUTHENTICATION_INITIALIZED';
export const AUTHENTICATION_LINKED_IN_STATE = 'AUTHENTICATION_LINKED_IN_STATE';
export const AUTHENTICATION_REFERRAL = 'AUTHENTICATION_REFERRAL';
export const AUTHENTICATION_SIGN_IN_WITH_LINKED_IN_COMPLETED = 'AUTHENTICATION_SIGN_IN_WITH_LINKED_IN_COMPLETED';
export const AUTHENTICATION_SIGN_IN_WITH_PASSWORD_COMPLETED = 'AUTHENTICATION_SIGN_IN_WITH_PASSWORD_COMPLETED';
export const AUTHENTICATION_SIGN_IN_SSO_COMPLETED = 'AUTHENTICATION_SIGN_IN_SSO_COMPLETED';
export const AUTHENTICATION_SIGN_IN_WORKOS_COMPLETED = 'AUTHENTICATION_SIGN_IN_WORKOS_COMPLETED';
export const AUTHENTICATION_SIGN_OUT = 'AUTHENTICATION_SIGN_OUT';

export const AUTHENTICATION_SIGN_IN_WITH_SHARED_CODE = 'AUTHENTICATION_SIGN_IN_WITH_SHARED_CODE';

export const AUTHENTICATION_SIGN_IN_WITH_LIVESTREAM = 'AUTHENTICATION_SIGN_IN_WITH_LIVESTREAM';

export const AUTHENTICATION_SCHEDULE = 'AUTHENTICATION_SCHEDULE';
export const AUTHENTICATION_MODERATED_MEETING = 'AUTHENTICATION_MODERATED_MEETING';

export const PARAMETERS_SET_COUPON = 'PARAMETERS_SET_COUPON';

// Schedule actions
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const SET_TIME_ZONE = 'SET_TIME_ZONE';
export const SET_INITIAL_DATE = 'SET_INITIAL_DATE';
export const SET_TIME_SLOT_SELECTED = 'SET_TIME_SLOT_SELECTED';
export const SET_TOUCHED = 'SET_TOUCHED';
export const SET_PROJECT_ID = 'SET_PROJECT_ID';
export const SET_LOCK_VERSION = 'SET_LOCK_VERSION';

// FIXME: Refactor action types bellow

export const AUTHENTICATION_SEND_PROFILE_INFORMATION = 'AUTHENTICATION_SEND_PROFILE_INFORMATION';
export const AUTHENTICATION_SEND_PROFILE_INFORMATION_COMPLETED = 'AUTHENTICATION_SEND_PROFILE_INFORMATION_COMPLETED';
export const AUTHENTICATION_SEND_PROFILE_INFORMATION_FAILURE = 'AUTHENTICATION_SEND_PROFILE_INFORMATION_FAILURE';
export const AUTHENTICATION_SIGN_IN = 'AUTHENTICATION_SIGN_IN';
export const AUTHENTICATION_SIGN_IN_COMPLETED = 'AUTHENTICATION_SIGN_IN_COMPLETED';
export const AUTHENTICATION_SIGN_IN_FAILED = 'AUTHENTICATION_SIGN_IN_FAILED';
export const AUTHENTICATION_SIGN_IN_TESTER = 'AUTHENTICATION_SIGN_IN_TESTER';

// Project actions
export const RESET_PROJECT = 'RESET_PROJECT';
export const SAVE_PROJECT_FORM = 'SAVE_PROJECT_FORM';
export const SAVE_PROJECT_TYPE = 'SAVE_PROJECT_TYPE';
export const SET_PROJECT = 'SET_PROJECT';
export const SET_PROJECT_ERROR = 'SET_PROJECT_ERROR';
export const SET_PROJECT_LOADING = 'SET_PROJECT_LOADING';
export const SET_SEGMENTS_ACCORDION_STATUS = 'SET_SEGMENTS_ACCORDION_STATUS';

// Screener actions
export const SCREENER_SESSION_FETCH_CURRENT = 'SCREENER_SESSION_FETCH_CURRENT';
export const SCREENER_SESSION_FETCH_CURRENT_COMPLETED = 'SCREENER_SESSION_FETCH_CURRENT_COMPLETED';
export const SCREENER_SESSION_FETCH_CURRENT_FAILED = 'SCREENER_SESSION_FETCH_CURRENT_FAILED';
export const SCREENER_SESSION_RESET_SURVEY = 'SCREENER_SESSION_RESET_SURVEY';
export const SCREENER_SESSION_SAVE_SURVEY_FORM = 'SCREENER_SESSION_SAVE_SURVEY_FORM';
export const SCREENER_SESSION_SAVE_SURVEY_TYPE = 'SCREENER_SESSION_SAVE_SURVEY_TYPE';
export const SCREENER_SESSION_SET_SURVEY = 'SCREENER_SESSION_SET_SURVEY';
export const SCREENER_SESSION_SURVEY_COMPLETED = 'SCREENER_SESSION_SURVEY_COMPLETED';
export const SCREENER_SESSION_SURVEY_UPLOAD_COMPLETED = 'SCREENER_SESSION_SURVEY_UPLOAD_COMPLETED';
export const SCREENER_SESSION_CURRENT_QUESTION = 'SCREENER_SESSION_CURRENT_QUESTION';
export const SCREENER_SESSION_NEXT_QUESTION = 'SCREENER_SESSION_NEXT_QUESTION';
export const SCREENER_SESSION_QUESTIONS_ORDER = 'SCREENER_SESSION_QUESTIONS_ORDER';
export const SCREENER_SESSION_SET_ANSWERS = 'SCREENER_SESSION_SET_ANSWERS';

// Meeting actions
export const SAVE_MEETING_ACCOUNT_TOKEN = 'SAVE_MEETING_ACCOUNT_TOKEN';

// Template actions
export const SET_TEMPLATE_VALUES = 'SET_TEMPLATE_VALUES';

// Tree test actions
export const TREE_TEST_QUESTIONS_ANSWERS = 'TREE_TEST_QUESTIONS_ANSWERS';
export const TREE_TEST_QUESTIONS_ORDER = 'TREE_TEST_QUESTIONS_ORDER';
export const TREE_TEST_NEXT_QUESTION = 'TREE_TEST_NEXT_QUESTION';
export const TREE_TEST_RESET_QUESTIONS = 'TREE_TEST_RESET_QUESTIONS';
export const TREE_TEST_PROJECT_VALUES = 'TREE_TEST_PROJECT_VALUES';
export const TREE_TEST_TEST_SESSION = 'TREE_TEST_TEST_SESSION';
export const TREE_TEST_RESET_SCREENER_ANSWERS = 'TREE_TEST_RESET_SCREENER_ANSWERS';
export const TREE_TEST_COMPLETED = 'TREE_TEST_COMPLETED';
export const TREE_TEST_ERROR = 'TREE_TEST_ERROR';

// Survey actions
export const SURVEY_PROJECT_VALUES = 'SURVEY_PROJECT_VALUES';
export const SURVEY_RESET_QUESTIONS = 'SURVEY_RESET_QUESTIONS';
export const SURVEY_TEST_SESSION = 'SURVEY_TEST_SESSION';
export const SURVEY_QUESTIONS = 'SURVEY_QUESTIONS';
export const NEXT_SURVEY_PAGE_QUESTIONS = 'NEXT_SURVEY_PAGE_QUESTIONS';
export const SURVEY_PAGE_QUESTIONS_ANSWERS = 'SURVEY_PAGE_QUESTIONS_ANSWERS';
export const SURVEY_ERROR = 'SURVEY_ERROR';

// USER
export const AUTHENTICATION_USER_STATUS = 'AUTHENTICATION_USER_STATUS';
export const SET_USER = 'SET_USER';
